import { Icon } from '@/app_components/common/Icon';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { VideoDefaultLoader } from '@/app_components/Video/loaders/VideoDefaultLoader';
import { cn } from '@/app_lib/utils/utils';

export const VideosLoader = ({ skeletonCount }: { skeletonCount: number }) => (
  <div className='flex flex-col layout-gap-xs'>
    <div className='flex flex-col layout-gap-md'>
      <div
        aria-hidden='true'
        className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 layout-grid-gap'
      >
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <VideoDefaultLoader
            className={cn(index > 4 && 'hidden md:block')}
            // biome-ignore lint/suspicious/noArrayIndexKey: This is a fake key
            key={`video-loader-${index}`}
            modal={false}
            orientation='vertical'
          />
        ))}
      </div>
    </div>
    <div
      aria-hidden='true'
      className='flex flex-col items-center gap-lg justify-center select-none cursor-default'
    >
      <span className='animate-pulse bg-helper text-transparent! typography-sm'>1-10 of 100</span>
      <ButtonV2
        as='button'
        className='animate-pulse bg-helper text-transparent! cursor-default'
        noCapitalize
        size='lg'
        variant='secondaryOutline'
      >
        <span className='animate-pulse bg-helper text-transparent! typography-sm'>See more videos</span>
        <Icon
          className='invisible'
          icon='ButtonDown'
          size='custom'
        />
      </ButtonV2>
    </div>
  </div>
);
